import axios from "../api/axios";
import useAuth from "./useAuth";

const useLogout = () => {
  const { setAuth } = useAuth();

  const logout = async () => {
    try {
      await axios.post('/logout', null, { withCredentials: true });
    } catch (err) {
      console.error(err);
    } finally {
      setAuth({});
    }
  }

  return logout;
}

export default useLogout
